import React, { FunctionComponent } from "react";

import "../../../css/nav_bar/nav_bar_controls_explorer.css";
import NavBarExportDropdownMenu from "./nav_bar_export_dropdown_menu";
import NavBarFloorDropdown from "./shared/nav_bar_floor_dropdown";
import NavBarKebabMenu from "./nav_bar_kebab_menu";
import NavBarManageUsersIcon from "./nav_bar_manage_users_icon";
import NavBarPanelsMenu from "./nav_bar_panels_menu";
import NavBarScanDropdown from "./shared/nav_bar_scan_dropdown";
import { useFlags } from "../../services/utilities/launch_darkly_helper";


export const NavBarControlsExplorer: FunctionComponent<Record<string, never>> = () => {
  const { customerFacingManageUsers } = useFlags();
  return <>
    <NavBarFloorDropdown/>
    <NavBarScanDropdown/>
    <NavBarPanelsMenu/>
    <NavBarExportDropdownMenu/>
    {customerFacingManageUsers && <NavBarManageUsersIcon/>}
    <NavBarKebabMenu/>
  </>;
};

export default React.memo(NavBarControlsExplorer);
